export default "__VITE_ASSET__CQPVal2p__"